import { filter, map } from 'lodash-es';
import { useMemo } from 'react';
import { childStatusI18nMap } from './childStatusI18nMap';
import { ChildTodoStatus } from 'views/Todo/service';
import { useTranslate } from '@tolgee/react';

export { useStatusLabel } from 'views/Todo/hooks/useLabel';

export const useTodoSubStatus = (data: ChildTodoStatus[], todoStatus: Todo.Status) => {
  const { t } = useTranslate();
  const subStatus = useMemo(() => {
    return map(
      filter(data, (item) => item.status === todoStatus),
      (each) => {
        return each.default
          ? { ...each, subStatusLabel: t(childStatusI18nMap[each.subStatus]) }
          : {
              ...each,
              subStatusLabel: each.subStatus,
            };
      },
    );
  }, [t, data, todoStatus]);

  return subStatus;
};
